import type { ButtonProps } from '@nuxt/ui'

import { useToast } from '@nuxt/ui/composables'

export type AppToastColor =
  | 'primary'
  | 'secondary'
  | 'success'
  | 'info'
  | 'warning'
  | 'error'
  | 'neutral'

export interface AppToastInput {
  title: string
  description?: string
  color?: AppToastColor
  duration?: number
  icon?: string
  actions?: ButtonProps[]
}

export function useAppToast() {
  const toast = useToast()

  return {
    add(input: AppToastInput): void {
      toast.add(input)
    },
  }
}
